import { render, staticRenderFns } from "./CbsObjectProcedure.vue?vue&type=template&id=d31bceb0&scoped=true"
import script from "./CbsObjectProcedure.vue?vue&type=script&lang=js"
export * from "./CbsObjectProcedure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31bceb0",
  null
  
)

export default component.exports